var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p',{class:_vm.extraClasses,style:({ fontFamily: _vm.randomFont }),on:{"click":function($event){return _vm.$emit('click')}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }